import type { ButtonHTMLAttributes } from 'react'
import type { TabsItem } from 'admination-react'

export type TabsPillItem = {
  key: string
  icon?: string
  text?: string
  title?: string
  action?: string
  isActive: boolean
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export function tabsPillProps(items: TabsPillItem[]) {
  return {
    items: items.map((item): TabsItem => ({
      name: item.key,
      label: item.text ?? item.title ?? '',
      icon: item.icon,
      title: item.title,
      htmlProps: item.action
        ? ({ 'data-action': item.action } as ButtonHTMLAttributes<HTMLButtonElement>)
        : undefined,
    })),
    activeName: items.find((item) => item.isActive)?.key ?? '',
    onChange: () => {},
    onItemClick: (name: string, event: React.MouseEvent<HTMLButtonElement>) => items.find((item) => item.key === name)?.onClick(event),
  }
}
